export var STATUS_TYPES = Object.freeze({
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error'
});